import { httpClient } from './httpClient'

export type SiteInfo = {
  metaSiteId: string
  thumbnailUrl: string
  siteName: string
  publicUrl: string
  isDefaultSiteName: boolean
}

export const fetchSiteInfo = (metaSiteId: string) =>
  httpClient.get<SiteInfo>(`/api/siteInfo?metaSiteId=${encodeURIComponent(metaSiteId)}`)
